<div class="card-header bg-{{style}}" [class.active]="isOpen">
  <a (click)="onClick($event)"
     [class.text-muted]="disabled"
     [tabindex]="tabIndex">
    <ng-content select="pcs-accordion-panel-header"></ng-content>
  </a>
</div>
<div *ngIf="isOpen"
     class="card-body collapse show"
     [class.text-muted]="disabled">
  <ng-content select="pcs-accordion-panel-content"></ng-content>
</div>
